export const advertiserUidGenerator = (isPublisherLevel, publisherId, publishersSupplySourcesId, advertiserId) => {
    return isPublisherLevel ?
    `${publisherId}-0-${advertiserId}` :
    `${publisherId}-${publishersSupplySourcesId}-${advertiserId}`;
}